import { ArrowDownRight, ArrowUpRight, Equal } from 'lucide-react'
import type { Totals } from '@/core/aggregation/totals'
import { formatBRL, formatOrig } from '../format'
import { Card, CardContent } from '../shadcn/card'

export interface TotalsFooterProps {
  totals: Totals
}

export function TotalsFooter({ totals }: TotalsFooterProps) {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-0">
        <div className="grid grid-cols-3 divide-x divide-border">
          <Stat
            label="Rendimentos"
            icon={<ArrowUpRight className="h-4 w-4 text-success" />}
            usd={totals.rendimentos.USD}
            cad={totals.rendimentos.CAD}
            brl={totals.rendimentos.BRL}
            accent="text-success"
          />
          <Stat
            label="Impostos pagos"
            icon={<ArrowDownRight className="h-4 w-4 text-destructive" />}
            usd={totals.impostos.USD}
            cad={totals.impostos.CAD}
            brl={totals.impostos.BRL}
            accent="text-destructive"
          />
          <Stat
            label="Líquido"
            icon={<Equal className="h-4 w-4 text-muted-foreground" />}
            usd={totals.rendimentos.USD - totals.impostos.USD}
            cad={totals.rendimentos.CAD - totals.impostos.CAD}
            brl={totals.liquidoBRL}
            accent="text-foreground"
            emphasis
          />
        </div>
      </CardContent>
    </Card>
  )
}

function Stat({
  label,
  icon,
  usd,
  cad,
  brl,
  accent,
  emphasis,
}: {
  label: string
  icon: React.ReactNode
  usd: number
  cad: number
  brl: number
  accent: string
  emphasis?: boolean
}) {
  return (
    <div className="p-6">
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-muted-foreground text-[10px] font-medium tracking-widest2 uppercase">
          {label}
        </span>
      </div>
      <div
        className={`mt-3 font-mono leading-none ${
          emphasis ? 'text-3xl font-display' : 'text-2xl font-medium'
        } ${accent}`}
      >
        R$ {formatBRL(brl)}
      </div>
      <div className="mt-3 grid grid-cols-2 gap-x-3 text-[11px] text-muted-foreground">
        <div>
          <span className="block text-[9px] tracking-widest2 uppercase">USD</span>
          <span className="font-mono">{formatOrig(usd)}</span>
        </div>
        <div>
          <span className="block text-[9px] tracking-widest2 uppercase">CAD</span>
          <span className="font-mono">{formatOrig(cad)}</span>
        </div>
      </div>
    </div>
  )
}
